import _ from 'lodash';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { apiSearch } from '../../modules/utility';

const apiBase = 'paycomFtpRecord';
const listName = `${apiBase}s`;
const idField = `${apiBase}Id`;
const idsField = `${idField}s`;

const search = ({ params = {}, callback = _.noop }) => {
	return (dispatch) => {
		apiSearch({
			base: apiBase,
			dispatch,
			params,
			callback,
		});
	};
};

const mapStateToProps = (state) => {
	const newState = {};
	newState[listName] = undefined;
	if (state.lists[idsField]) {
		newState[listName] = _.map(state.lists[idsField], (id) => state.maps[apiBase][id]);
	}

	newState.userMap = state.maps.user;
	newState.resourceMap = state.maps.resource;
	return newState;
};

const mapDispatchToProps = (dispatch) =>
	bindActionCreators(
		{
			searchPaycomFtpRecords: search,
		},
		dispatch
	);

export default connect(mapStateToProps, mapDispatchToProps);
